module.exports = __webpack_public_path__ + "img/76.aaca26d4.jpg";